// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bPrincipal[data-v-5d953520]{float:right}.dBtnTop[data-v-5d953520]{margin-bottom:15px}.dBtnBottom[data-v-5d953520]{margin-top:15px}", ""]);
// Exports
module.exports = exports;
